
export function productPageSlider() {
    $(".main-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: ".nav-slider",
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                },
            },
        ],
    });

    $(".nav-slider").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: ".main-slider",
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });

    $(".nav-slider .slick-slide").on("click", function () {
        var index = $(this).data("slick-index");
        $(".main-slider").slick("slickGoTo", index);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/productPageSlider.js